import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanDeactivate,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { HeaderPageComponent } from '../pages/cms/header/header-page.component';
import { FormChangedGuard } from './form-changed-guard/form-changed-guard';

@Injectable({
  providedIn: 'root',
})
export class HeaderFormChangedGuard
  extends FormChangedGuard
  implements CanDeactivate<HeaderPageComponent>
{
  canDeactivate(
    component: HeaderPageComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.handleNavigation(
      component.hasUnsavedChanges(component.headerForm),
      nextState.url,
      () => component.resetFormChanges,
      () => component.save()
    );
  }
}
